export default {
  create({ userId }, data, BACKEND) {
    return {
      seqRound:       data.seqRound, // round 1 = first time, round 2 = second time
      seqItemId:      data.seqItemId,       // in seconds
      taskId:         data.taskId,
    }
  },

  fields: {
    seqRound: {},
    seqItemId: {},
    taskId: {},
  }
};
